import { oz } from '@weft/utils';
import { CurrencySchema, PeriodSchema, TimeSlotSchema } from '../../primitives';

export const NewFixedVariantChargeSchema = oz.object({
  accountId: oz.string(),
  customerId: oz.string(),
  productVariantId: oz.string(),
  invoiceId: oz.string().nullish(),
  contractId: oz.string(),
  period: PeriodSchema,
  timeSlot: TimeSlotSchema,
  price: oz.number(),
  deferredPrice: oz.number().optional(),
  currency: CurrencySchema,
  tierIndex: oz.number().nullish(),
});

export type NewFixedVariantCharge = oz.infer<typeof NewFixedVariantChargeSchema>;